// extracted by mini-css-extract-plugin
module.exports = {"TableBuilder":"TableBuilder_TableBuilder__2WtlT"};